import {
  Animated,
  ImageBackground,
  ScrollView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import { useEffect, useRef, useState } from "react";
import {
  BtnSidebarClosePng,
  InputField,
  ModalTitle,
  ProfileRegistration,
  SaveButton,
} from "../../../assets";

import { useDevice } from "../../../utils/hooks/useDevice";
import { useTranslation } from "react-i18next";
import ModalReusable from "../Modals/ModalReusable";
import { useDispatch, useSelector } from "react-redux";
import {
  profileRequest,
  updateProfileRequest,
} from "../../../store/auth/authActions";
import Toast from "react-native-toast-message";
import { RootState } from "../../../store";

type MessagesModalProps = {
  onClose: () => void;
};

const ProfileEditModal = ({ onClose }: MessagesModalProps) => {
  const { t } = useTranslation();
  const opacity = useRef(new Animated.Value(0)).current;

  const dispatch = useDispatch();
  const { isDesktop } = useDevice();

  const { user, profileLoading } = useSelector((s: RootState) => ({
    user: s.auth.user,
    profileLoading: s.auth.profileLoading,
  }));

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (!user) dispatch(profileRequest());
  }, [dispatch, user]);

  useEffect(() => {
    if (user) {
      setUsername(user.username ?? "");
      setEmail(user.email ?? "");
    }
  }, [user]);

  useEffect(() => {
    Animated.timing(opacity, {
      toValue: 1,
      duration: 200,
      useNativeDriver: true,
    }).start();

    return () => {
      opacity.setValue(0);
    };
  }, []);

  const handleClose = () => {
    Animated.timing(opacity, {
      toValue: 0,
      duration: 200,
      useNativeDriver: true,
    }).start(() => {
      onClose();
    });
  };

  // const isEmailValid = (e: string) =>
  //   /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.trim());

  const onSave = () => {
    const payload: Partial<{
      username: string;
      email: string;
    }> = {};

    const trimmedUsername = username.trim();
    const trimmedEmail = email.trim();

    if (!trimmedUsername) {
      Toast.show({ type: "error", text1: "Username is required" });
      return;
    }
    // if (!isEmailValid(trimmedEmail)) {
    //   Toast.show({ type: "error", text1: "Invalid email" });
    //   return;
    // }

    payload.username = trimmedUsername;
    // payload.email = trimmedEmail;

    dispatch(updateProfileRequest(payload as any));

    Toast.show({
      type: "success",
      text1: "Profile updated",
      text2: "Your changes have been saved",
    });

    handleClose();
  };

  return (
    <>
      <ModalReusable
        visible
        onClose={onClose}
        // backgroundImage={ProfileRegistration}
        titleImage={ModalTitle}
        closeIcon={BtnSidebarClosePng}
        title={t("T_SITE_PROFILE_PROFILE")}
        titleImageStyles={{ top: -60, width: 240, height: 100 }}
        titleTextStyles={{ width: 240, height: 100 }}
      >
        <ScrollView
          contentContainerStyle={[
            styles.container,
            {
              minWidth: isDesktop ? 300 : 300,
              gap: isDesktop ? 10 : 6,
              minHeight: isDesktop ? 320 : 320,
            },
          ]}
        >
          <View style={styles.form}>
            <Text style={styles.label}>
              {t("T_SITE_PROFILE_MODAL_USERNAME") || "Username"}:
            </Text>
            <ImageBackground
              source={InputField}
              resizeMode="stretch"
              style={styles.inputWrapper}
            >
              <TextInput
                value={username}
                onChangeText={setUsername}
                style={styles.input}
                autoCapitalize="none"
                autoCorrect={false}
                editable={!profileLoading}
                placeholder={t("T_SITE_PROFILE_MODAL_USERNAME") || "Username"}
                placeholderTextColor="#bbb"
              />
            </ImageBackground>

            {/* <Text style={styles.label}>
              {t("T_SITE_PROFILE_MODAL_EMAIL") || "E-mail"}
            </Text>
            <ImageBackground
              source={InputField}
              resizeMode="stretch"
              style={styles.inputWrapper}
            >
              <TextInput
                value={email}
                onChangeText={setEmail}
                style={styles.input}
                autoCapitalize="none"
                autoCorrect={false}
                keyboardType="email-address"
                editable={!profileLoading}
                placeholder={t("T_SITE_PROFILE_MODAL_EMAIL") || "E-mail"}
                placeholderTextColor="#bbb"
              />
            </ImageBackground> */}

            <TouchableOpacity onPress={onSave} style={{ alignSelf: "center" }}>
              <ImageBackground
                source={SaveButton}
                style={{ width: 160, height: 80 }}
                resizeMode="contain"
              >
                <View
                  style={{
                    flex: 1,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Text style={styles.text}>
                    {" "}
                    {t("T_SITE_PROFILE_MODAL_SAVE") || "Save"}
                  </Text>
                </View>
              </ImageBackground>
            </TouchableOpacity>
          </View>
        </ScrollView>
      </ModalReusable>
    </>
  );
};

export default ProfileEditModal;

const styles = StyleSheet.create({
  container: {
    padding: 16,
  },
  form: {
    alignItems: "center",
    height: 200,
    width: 200,
    minWidth: 304,
  },
  label: {
    color: "white",
    fontSize: 18,
    alignSelf: "flex-start",
    marginBottom: 4,
  },
  inputWrapper: {
    width: 300,
    height: 60,
    marginBottom: 20,
    justifyContent: "center",
    paddingHorizontal: 12,
  },
  input: {
    color: "white",
    fontSize: 20,
    padding: 0,
  },
  saveButton: {
    width: 210,
    height: 70,
    justifyContent: "center",
    alignItems: "center",
  },
  saveButtonText: {
    color: "white",
    fontSize: 22,
    fontWeight: "bold",
    textShadowColor: "#000",
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 2,
  },
  text: {
    fontSize: 20,
    fontWeight: "900",
    letterSpacing: 1,
    color: "#E0E0E0",
    textShadowColor: "rgba(0, 0, 0, 0.6)",
    textShadowOffset: { width: 0, height: 2 },
    textShadowRadius: 2,
    textTransform: "uppercase",
    paddingBottom: 2,
  },
});
